<template>
  <!-- I haven't made any change to this template. This is only copy and paste from doc site. -->
  <div>
    <v-container>
      <v-layout row wrap>
        <v-flex xs6>
          <v-pagination
            @input="changepage"
            v-model="page"
            :length="pagelength"
            :total-visible="7"
          ></v-pagination>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <importxlsx @onChange="importCsv"></importxlsx>
            <!-- <exportxlsx v-model="xlsxdata"></exportxlsx> -->
            <v-btn dark outline color="primary" @click="getXlsxData" :loading="loadingExport">
              <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
            </v-btn>
            <v-btn outline color="primary" @click="showAdvanceSearch"> Advance search </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="items"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <tr @click="showDetail(props.item)" style="cursor: pointer">
            <td>
              <v-img class="mx-auto" width="120px" :src="props.item.image_link"></v-img>
            </td>
            <td>{{ props.item.title }}</td>
            <td>{{ props.item.category }}</td>
            <td>{{ props.item.keywords }}</td>
            <td>{{ props.item.short_description }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog v-model="detaildialog" width="660px">
      <v-card>
        <div class="text-xs-right">
          <v-btn @click="detaildialog = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div><ProductDetail v-if="detaildialog" :detaildata="detaildata"></ProductDetail></div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="advancesearch" persistent width="500px">
      <v-card class="pa-3">
        <div class="text-xs-right">
          <v-btn @click="advancesearch = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div class="form-control">
          <label>Title </label>
          <input v-model="search.title" type="text" />
        </div>
        <div class="form-control">
          <label>Category </label>
          <input v-model="search.category" type="text" />
        </div>
        <div class="form-control">
          <label>Keywords</label>
          <input v-model="search.keywords" type="text" />
        </div>

        <div>
          <v-btn @click="onSearch" block color="primary" depressed>ค้นหา</v-btn>
          <v-btn @click="clearSearch" block color="grey" outline>Clear search</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import ProductDetail from './ProductDetail.vue'
import XLSX from 'xlsx'
import api from '@/api'

export default {
  components: {
    exportxlsx,
    importxlsx,
    ToggleButton,
    ProductDetail
  },
  data: () => ({
    loading: false,
    limit: 10,
    page: 1,
    pagetmp: 1,
    pagetotal: 0,
    offset: 0,
    loadingExport: false,
    detaildialog: false,
    detaildata: '',
    search: {
      title: '',
      location_group: '',
      place: '',
      province: ''
    },
    headers: [
      {
        text: '',
        align: 'center',
        sortable: false,
        value: 'image'
      },
      {
        text: 'Title',
        align: 'center',
        // sortable: false,
        value: 'title'
      },
      {
        text: 'Category',
        align: 'center',
        value: 'category'
      },
      { text: 'Keyword', align: 'center', value: 'keyword' },
      { text: 'Short description', align: 'center', value: 'description' }
    ],
    items: [
      {
        name: 'Studio 7-Paradise Park',
        locationgroup: 'Paradise Park',
        location: 'Srinakarin',
        building: 'Paradise Park',
        province: 'Bangkok',
        status: false
      }
    ],
    advancesearch: false
  }),

  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.pagetotal) {
        return Math.ceil(this.pagetotal / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getProducts()
  },
  methods: {
    showAdvanceSearch() {
      this.advancesearch = true
    },
    changepage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.getProducts()
      }
    },
    onSearch() {
      this.getProducts()
      this.advancesearch = false
    },
    clearSearch() {
      let data = {}
      for (const [key, value] of Object.entries(this.search)) {
        if (value) {
          Object.assign(data, { [key]: '' })
        }
      }
      this.search = data
      this.advancesearch = false
      this.getProducts()
    },
    async getExportProduct() {
      const vm = this
      return new Promise((resolve) => {
        let data = {
          limit: vm.pagetotal,
          offset: vm.offset,
          pageid: vm.selectedBot.pageid
        }
        for (const [key, value] of Object.entries(vm.search)) {
          if (value) {
            Object.assign(data, { [key]: value })
          }
        }
        vm.loadingExport = true
        api.com7getproducts(data, (err, response) => {
          if (err) {
            console.error(err)
            return
          }
          if (response) {
            vm.loadingExport = false
            resolve(response.data)
          }
        })
      })
    },
    async getXlsxData() {
      const vm = this
      const data = await vm.getExportProduct()

      let json = data.map((el) => {
        return {
          id: el.product_id,
          title: el.title,
          category: el.category,
          keywords: el.keywords,
          description: el.description,
          image_link: el.image_link,
          link: el.links,
          price: el.price,
          sale_price: el.sale_price,
          sale_price_effective_date: el.effective_date,
          availability: el.availability,
          product_type: el.product_type,
          brand: el.brand,
          condition: el.condition,
          adult: el.adult,
          color: el.color,
          gender: el.gender,
          size: el.size,
          'Short Description': el.short_description,
          weight: el.weight
        }
      })

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_json(ws, json)
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `export-products.xlsx`)
    },
    getProducts() {
      const vm = this
      vm.offset = vm.page * 10 - 10
      if (vm.page != 1) {
        vm.offset + 1
      }
      let data = {
        limit: vm.limit,
        offset: vm.offset,
        pageid: vm.selectedBot.pageid
      }
      for (const [key, value] of Object.entries(vm.search)) {
        if (value) {
          Object.assign(data, { [key]: value })
        }
      }
      vm.loading = true
      api.com7getproducts(data, (err, response) => {
        if (err) {
          console.error(err)
          return
        }
        if (response) {
          vm.pagetotal = parseInt(response.total)
          vm.loading = false
          vm.items = response.data
        }
      })
    },
    showDetail(item) {
      this.detaildata = item
      this.detaildialog = true
    },
    onChangeBranchStatus(index) {
      this.items[index].status = !this.items[index].status
    },
    importCsv(file) {
      var data = {
        files: file[0],
        pageid: this.selectedBot.pageid
      }
      api.com7importproducts(data, async (err, response) => {
        if (response.responsecode == 200) {
          await this.$swal.fire({
            type: 'success',
            text: 'สำเร็จ'
          })
          this.getProducts()
        }
      })
    },
    deleteItem(item) {
      const index = this.items.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket2/productandbranch/Product.vue